/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { Lock, Clock, CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { assets } from "../assets/assets";

const NotOnboardedMessage = ({ featureName = "this feature" }) => {
  const { t } = useTranslation();
  const isDarkMode = document.documentElement.classList.contains("dark");

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <div className="relative max-w-xl w-full">
        {/* Main card */}
        <div className="relative bg-gradient-to-br from-card to-background dark:from-dark-surface dark:to-dark-surface/80 border border-gray-200 dark:border-dark-border rounded-3xl p-8 shadow-xl shadow-primary/10 dark:shadow-primary/5 backdrop-blur-sm">
          <div className="relative mb-6">
            <div className="relative flex flex-col items-center">
              <div className="relative z-10 w-24 h-24 rounded-2xl flex items-center justify-center  mb-3 p-2">
                <img
                  className="w-full h-full object-contain"
                  src={isDarkMode ? assets.admin_logo_white : assets.admin_logo}
                  alt="Logo"
                />
              </div>
              <div className="absolute -right-2 -top-2 bg-white dark:bg-dark-surface p-1.5 rounded-full shadow-md border border-gray-100 dark:border-dark-border">
                <Clock className="w-5 h-5 text-primary dark:text-primary" />
              </div>
            </div>
          </div>

          <div className="relative mb-4 text-center">
            <div className="flex flex-col items-center justify-center gap-2 mb-2">
              <h2 className="text-2xl font-bold bg-gradient-to-r from-primary to-secondary dark:from-primary dark:to-secondary bg-clip-text text-transparent">
                {t("message.notOnboarded.title")}
              </h2>
              <p className="text-sm text-primary/80 dark:text-primary/90 font-medium">
                {t("message.notOnboarded.status")}
              </p>
            </div>
          </div>

          <div className="mb-6">
            <div className="bg-gradient-to-r from-accent to-background dark:from-dark-surface dark:to-dark-background rounded-2xl p-4 mb-4 border border-gray-100 dark:border-dark-border">
              <p className="text-center text-text dark:text-dark-text leading-relaxed">
                {t("message.notOnboarded.desc1")} {t("message.notOnboarded.desc2")}
              </p>
            </div>

            <div className="flex items-center gap-3 bg-card dark:bg-dark-surface rounded-xl p-4 border border-gray-100 dark:border-dark-border shadow-sm">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 dark:bg-primary/20 rounded-lg flex items-center justify-center">
                <Lock className="w-5 h-5 text-primary dark:text-primary" />
              </div>
              <div className="text-left">
                <p className="text-sm font-medium text-text dark:text-dark-text">
                  Once you&apos;re{" "}
                  <span className="text-primary dark:text-primary font-bold">
                    Onboarded
                  </span>
                  , you&apos;ll gain access to:
                </p>
                <p className="text-sm text-gray-600 dark:text-dark-muted mt-1">
                  <span className="font-semibold text-primary dark:text-primary capitalize">
                    {featureName}
                  </span>{" "}
                  and all platform features
                </p>
              </div>
            </div>
          </div>

          {/* Benefits section */}
          <div className="grid grid-cols-2 gap-3 mb-6">
            <div className="flex items-center gap-2 bg-accent/50 dark:bg-dark-surface/50 rounded-xl p-3">
              <CheckCircle className="w-4 h-4 text-primary dark:text-primary" />
              <span className="text-xs font-medium text-text dark:text-dark-text">
                Job Access
              </span>
            </div>
            <div className="flex items-center gap-2 bg-accent/50 dark:bg-dark-surface/50 rounded-xl p-3">
              <CheckCircle className="w-4 h-4 text-primary dark:text-primary" />
              <span className="text-xs font-medium text-text dark:text-dark-text">
                See Booking Requests
              </span>
            </div>
            <div className="flex items-center gap-2 bg-accent/50 dark:bg-dark-surface/50 rounded-xl p-3">
              <CheckCircle className="w-4 h-4 text-primary dark:text-primary" />
              <span className="text-xs font-medium text-text dark:text-dark-text">
                Apply to Jobs
              </span>
            </div>
            <div className="flex items-center gap-2 bg-accent/50 dark:bg-dark-surface/50 rounded-xl p-3">
              <CheckCircle className="w-4 h-4 text-primary dark:text-primary" />
              <span className="text-xs font-medium text-text dark:text-dark-text">
                Earn Income
              </span>
            </div>
          </div>

          {/* Footer note */}
          <div className="text-center">
            <p className="text-xs text-gray-500 dark:text-dark-muted">
              {t("message.notOnboarded.refresh")}
              <span className="block text-primary dark:text-primary font-medium mt-1">
                Thank you for your patience!
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotOnboardedMessage;
